import axios from "axios";

// Same logic: prefer env, otherwise match host:5000
const envBase = process.env.REACT_APP_API_BASE_URL;

const isLocalHost =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.hostname.startsWith("192.168.") ||
    window.location.hostname.startsWith("10.") ||
    window.location.hostname.startsWith("172.16."));

const API_BASE =
  envBase ||
  (isLocalHost
    ? `${window.location.protocol}//${window.location.hostname}:5000`
    : "https://api.unicodexglobal.com");

const adminApi = axios.create({
  baseURL: API_BASE,
  timeout: 15000,
});

// Attach Bearer token from localStorage if present
adminApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("ucx_admin_token");
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

adminApi.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default adminApi;
